export const convertEmToPx = (em: number) => parseFloat(getComputedStyle(document.documentElement).fontSize) * em
